import { Component, OnInit } from '@angular/core';
import { Modal } from 'bootstrap';
import { StateService } from 'src/app/services/state.service';
import { TabletRoutinesService } from 'src/app/services/tablet-routines.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-tablet-autoassined-routines',
  templateUrl: './tablet-autoassined-routines.component.html',
  styleUrls: ['./tablet-autoassined-routines.component.scss'],
})
export class TabletAutoassinedRoutinesComponent implements OnInit {
  autoassignedRoutines: any[] = [];

  constructor(
    private tabletRoutinesService: TabletRoutinesService,
    private toastService: ToastService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.getTabletRoutines();

    setInterval(() => {
      this.getTabletRoutines();
    }, 60000);
  }

  getTabletRoutines() {
    this.tabletRoutinesService.getAutoAssignedRoutines().subscribe({
      next: (response: any) => {
        this.autoassignedRoutines = response;
      },
      error: (error) => {
        this.toastService.alert('Error trayendo las rutinas');
      },
    });
  }

  selectTabletRoutine(routine: any) {
    this.stateService.selectedTabletRoutine = routine;
  }

  openFormModal() {
    const modal = new Modal('#routineFormTablet');
    this.stateService.openModal = modal;
    modal.show();

    const modalHtmlElement = document.getElementById('routineFormTablet')!;

    modalHtmlElement.addEventListener('hidden.bs.modal', () => {
      this.getTabletRoutines();
    });
  }
}
